import WarehouseIcon from '@mui/icons-material/Warehouse';

export const warehouseReturnsConfig = (isFulfilment,hasReturnManagePermission) => {
    return {
        returns:  {
            title: 'all_returns',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        ...(hasReturnManagePermission && {
            paidReturnsWithoutShipments:  {
                title: 'paid_returns_no_shipments',
                icon: <WarehouseIcon/>,
                isSingleDataGrid: true,
            },
        }),
        returnlines:  {
            title: 'return_lines',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        internalReasons: {
            title: 'internal_return_reasons',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        // ...(!isFulfilment && {
        //     // design: {
        //     //     title: 'design',
        //     //     icon: <WarehouseIcon/>,
        //     //     isSingleDataGrid: false,
        //     // },
        //     // returnReasons: {
        //     //     title: 'return_reasons',
        //     //     icon: <WarehouseIcon/>,
        //     //     isSingleDataGrid: true,
        //     // }
            
        // })
    };
};
